import { render, staticRenderFns } from "./SiftCascader.vue?vue&type=template&id=5fb98bee&scoped=true&"
import script from "./SiftCascader.vue?vue&type=script&lang=js&"
export * from "./SiftCascader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb98bee",
  null
  
)

export default component.exports